import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { track } from '../../utils/analytics';
import { AnalyticsEvents } from '../../utils/analyticsEvents';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import LandingHeroSection from './LandingHeroSection';
import LandingHowItWorksSection from './LandingHowItWorksSection';
import LandingFeaturesSection from './LandingFeaturesSection';
import LandingValueSection from './LandingValueSection';
import LandingPricingSection from './LandingPricingSection';
import LandingFaqSection from './LandingFaqSection';
import LandingCtaSection from './LandingCtaSection';
import LandingFooter from './LandingFooter';
import './LandingPage.css';

const LandingPage: React.FC = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  const handleStartTrial = () => {
    track(AnalyticsEvents.LANDING_CTA_CLICK, { destination: user ? 'dashboard' : 'signup' });
    if (user) {
      navigate('/dashboard');
    } else {
      navigate('/signup');
    }
  };

  return (
    <div className="landing-page">
      <div className="landing-page__cta-float lg:hidden">
        <button
          onClick={handleStartTrial}
          className="p-2.5 sm:p-3 bg-gradient-to-r from-blue-600 to-cyan-500 rounded-full shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 text-white inline-flex items-center justify-center"
        >
          <span className="sr-only">Get Started</span>
          <ArrowRightIcon className="h-5 w-5 sm:h-5 sm:w-5" />
        </button>
      </div>

      <LandingHeroSection
        user={user}
        loading={loading}
        onStartTrial={handleStartTrial}
      />
      <LandingFeaturesSection />
      <LandingHowItWorksSection />
      <LandingValueSection />
      <LandingPricingSection />
      <LandingFaqSection />
      <LandingCtaSection user={user} onStartTrial={handleStartTrial} />
      <LandingFooter />
    </div>
  );
};

export default LandingPage;
